import { render, staticRenderFns } from "./CodeSnippetLoader.vue?vue&type=template&id=5df7dd9e&scoped=true"
import script from "./CodeSnippetLoader.vue?vue&type=script&lang=js"
export * from "./CodeSnippetLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df7dd9e",
  null
  
)

export default component.exports